var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisingStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4531 116.609V118.016H37.5781V124.391C38.2109 124.367 38.7969 124.305 39.4531 124.156L39.6406 125.594C38.5781 125.82 37.6875 125.836 36.5312 125.828H35.8594V116.609H39.4531ZM40.1719 125.828V116.609H44.0312V118.016H41.9062V124.398C42.9062 124.383 43.6641 124.32 44.5156 124.125L44.6562 125.531C43.5 125.812 42.5391 125.836 40.9375 125.828H40.1719ZM43.4062 121.688V120.281H45.7656V115.266H47.5V129.391H45.7656V121.688H43.4062ZM55.75 116.062C58.7812 116.07 61.0234 117.578 61.0156 119.875C61.0234 121.992 59.2031 123.406 56.6094 123.664V126.25H62.2344V127.672H49.3281V126.25H54.8906V123.664C52.3281 123.406 50.5078 121.992 50.5156 119.875C50.5078 117.578 52.7422 116.07 55.75 116.062ZM52.2188 119.875C52.2109 121.398 53.6875 122.312 55.75 122.312C57.8438 122.312 59.3125 121.398 59.3125 119.875C59.3125 118.398 57.8438 117.461 55.75 117.469C53.6875 117.461 52.2109 118.398 52.2188 119.875ZM76.0625 126.297V127.719H63.1562V126.297H76.0625ZM64.6562 117.672V116.266H74.5312V120.812H66.4219V122.656H74.8594V124.031H64.6875V119.422H72.8125V117.672H64.6562ZM88.4219 119.266V120.641H78.6406V115.781H80.3594V119.266H88.4219ZM76.9688 123.656V122.281H89.875V123.656H76.9688ZM78.5156 129.062V124.906H80.25V127.656H88.5156V129.062H78.5156ZM106.438 115.266V122.562H104.703V121.031H101.859V122.109H95.25V115.891H96.9844V117.672H100.141V115.891H101.859V117.141H104.703V115.266H106.438ZM96.9844 120.734H100.141V119H96.9844V120.734ZM97.125 124.5V123.141H106.438V126.766H98.875V127.844H106.891V129.219H97.1406V125.484H104.703V124.5H97.125ZM101.859 119.703H104.703V118.453H101.859V119.703Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.019 48.9995C119.019 75.5248 97.5238 97.0195 70.9985 97.0195C44.4732 97.0195 22.9785 75.5248 22.9785 48.9995C22.9785 22.4742 44.4732 0.979492 70.9985 0.979492C97.5238 0.979492 119.019 22.4742 119.019 48.9995Z",
    fill: "url(#paint0_linear_1275_5291)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.49 48.9999C113.49 72.4668 94.4668 91.4905 70.9999 91.4905C47.533 91.4905 28.5093 72.4668 28.5093 48.9999C28.5093 25.533 47.533 6.50933 70.9999 6.50933C94.4668 6.50933 113.49 25.533 113.49 48.9999Z",
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1275_5291)",
    filter: "url(#filter1_i_1275_5291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.6416 40.3789H49.0261C47.8631 40.3789 46.9375 41.3287 46.9375 42.4685V67.0215C46.9375 68.185 47.8869 69.1111 49.0261 69.1111H57.6416C58.8046 69.1111 59.7303 68.1612 59.7303 67.0215V42.4923C59.7303 41.3287 58.8046 40.3789 57.6416 40.3789Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.178 40.3789H76.1305C76.1305 40.3789 79.3821 36.5559 80.7824 30.9994C81.447 28.3399 80.7587 24.5406 79.3583 23.0209C78.0055 21.5487 75.5609 22.166 75.0624 24.1132L73.7571 29.266C73.2586 31.1894 72.2381 32.9465 70.814 34.3475L64.6431 40.3789L64.026 40.9725C63.8599 41.115 63.7175 41.2812 63.5988 41.4475C63.3615 41.8274 63.1953 42.2785 63.1953 42.7535V66.8552C63.1953 68.185 64.2634 69.2535 65.5925 69.2535H80.7587C85.5055 69.2535 89.659 66.0479 90.8932 61.465L95.1416 45.5317C95.8299 42.9434 93.8837 40.3789 91.178 40.3789Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5291",
    x: 27.2266,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5291"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5291",
    x: 46.9355,
    y: 22.2139,
    width: 48.3457,
    height: 48.0663,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5291"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5291",
    x1: 37.6785,
    y1: 11.4328,
    x2: 107.749,
    y2: 79.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1275_5291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.3467,
    height: 47.04,
    fill: "white",
    transform: "translate(46.9355 22.2139)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisingStar);
export default __webpack_public_path__ + "static/media/RisingStar.b1cbf8473653c328800aadf73e440ca4.svg";
export { ForwardRef as ReactComponent };